import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import StudentLayout from './StudentLayout';
import Particles from 'react-tsparticles';
import { loadFull } from 'tsparticles';

function BlockbustersWelcome() {
  const [showInstructions, setShowInstructions] = useState(false);
  const [musicPlaying, setMusicPlaying] = useState(true);
  const audioRef = useRef(null);
  const navigate = useNavigate();
  const { assignmentId } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const studentUID = queryParams.get('studentUID');
  
  const particlesInit = useCallback(async (engine) => {
    await loadFull(engine);
  }, []);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = 0.05;
  
      if (musicPlaying) {
        const playPromise = audioRef.current.play();
        if (playPromise !== undefined) {
          playPromise.catch((error) => {
            console.warn('Autoplay blocked until user interacts.');
          });
        }
      } else {
        audioRef.current.pause(); // ✅ Pause the music when musicPlaying is false
      }
    }
  }, [musicPlaying]);

  return (
    
    <StudentLayout>
      <Particles
        id="tsparticles"
        init={particlesInit}
        options={{
          fullScreen: { enable: true, zIndex: 0 },
          background: { color: { value: "#f3f9ff" } },
          particles: {
            number: { value: 40, density: { enable: true, area: 800 } },
            color: { value: ["#ffd700", "#ffffff", "#87cefa"] },
            shape: { type: "star" },
            opacity: { value: 0.9 },
            size: { value: { min: 1, max: 4 } },
            move: {
              enable: true,
              speed: 1,
              direction: "none",
              outModes: { default: "bounce" },
            }
          },
          interactivity: {
            events: {
              onHover: { enable: true, mode: "repulse" },
              resize: true,
            },
            modes: {
              repulse: { distance: 100, duration: 0.4 }
            }
          },
          detectRetina: true
        }}
      />

      <audio ref={audioRef} src="/BlockBusters/Blockbusters_Theme.mp3" loop />
{/* 🎵 Toggle Button */}
<button
  onClick={() => setMusicPlaying(prev => !prev)}
  style={{
    position: 'absolute',
    top: '70px',
    right: '20px',
    zIndex: 100, // Make sure it's above other elements
    backgroundColor: 'transparent',
    border: 'none',
    fontSize: '60px',
    cursor: 'pointer',
    color: '#2c3e50',
    
  }}
  title={musicPlaying ? 'Pause Music' : 'Play Music'}
>
  {musicPlaying ? '🔊' : '🔇'}
</button>
      


      {/* Main Content */}
      <div style={{
        position: 'relative',
        zIndex: 1,
        textAlign: 'center',
        padding: '60px 20px',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        {!showInstructions ? (
          <>
            <img
              src="https://firebasestorage.googleapis.com/v0/b/ryan-tutors.firebasestorage.app/o/images%2FBlockbusters_logo.png?alt=media&token=4f862aa6-e973-4929-a3c6-13eb5bce0330"
              alt="Blockbusters Logo"
              style={{ width: '380px', marginBottom: '20px' }}
            />
            <h1 style={{
              fontSize: '38px',
              fontWeight: 'bold',
              color: '#2c3e50',
              marginBottom: '40px',
            }}>
              Welcome to Blockbusters!
            </h1>

            <div style={{
              display: 'flex',
              gap: '20px',
              flexWrap: 'wrap',
              justifyContent: 'center',
            }}>
              
              <button
                onClick={() => navigate(`/blockbusters-game/${assignmentId}?studentUID=${studentUID}`)}
                style={{
                  padding: '15px 30px',
                  fontSize: '18px',
                  fontWeight: 'bold',
                  borderRadius: '10px',
                  border: 'none',
                  cursor: 'pointer',
                  backgroundColor: '#ffd700',
                  color: '#000',
                }}
              >
                🎮 Start Game
              </button>

              <button
                onClick={() => setShowInstructions(true)}
                style={{
                  padding: '15px 30px',
                  fontSize: '18px',
                  fontWeight: 'bold',
                  borderRadius: '10px',
                  border: 'none',
                  cursor: 'pointer',
                  backgroundColor: '#87cefa',
                  color: '#000',
                }}
              >
                📖 How to Play
              </button>
            </div>
          </>
        ) : (
          
          <div style={{
            backgroundColor: '#ffffff',
            color: '#2c3e50',
            padding: '30px',
            borderRadius: '12px',
            maxWidth: '700px',
            textAlign: 'left',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            marginTop: '40px',
          }}>
            <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>📖 How to Play</h2>
            <ol style={{ lineHeight: 1.8, fontSize: '18px', paddingLeft: '20px' }}>
              <li><strong>Choose a tile</strong> from the golden grid to begin.</li>
              <li>You'll be faced with a <strong>maths question</strong>.</li>
              <li>Type your answer and show your working out beside it.</li>
              <li>Correct answers turn the tile <strong>blue</strong>.</li>
              <li>Create a full path across the board to win!</li>
              <li>You get <strong>two tries</strong> per tile before the tile turns <strong>white</strong> and locks.</li>
            </ol>
            <div style={{ textAlign: 'center', marginTop: '30px' }}>
              <button
                onClick={() => setShowInstructions(false)}
                style={{
                  padding: '10px 20px',
                  fontSize: '16px',
                  backgroundColor: '#ffd700',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                }}
              >
                🎯 Got it! Back to Game
              </button>
              
            </div>
          </div>
        )}
      </div>
    </StudentLayout>
  );
}

export default BlockbustersWelcome;
